module.exports = __webpack_public_path__ + "img/clear-input.e2d7debe.svg";